export default "__VITE_ASSET__DnPtddsD__ 720w";